import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import pure from 'recompose/pure';
import PersonalizationWizard from './PersonalizationWizard';

const PersonalizePageForm = ({ className, source, record = {}, ...rest }) => {
    return (
        <PersonalizationWizard data={record} source={source} options={{ fullWidth: true }} />
    );
};

PersonalizePageForm.propTypes = {
    addLabel: PropTypes.bool,
    basePath: PropTypes.string,
    className: PropTypes.string,
    cellClassName: PropTypes.string,
    headerClassName: PropTypes.string,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

const PurePersonalizePageForm = pure(PersonalizePageForm);

PurePersonalizePageForm.defaultProps = {
    addLabel: true,
};

export default PurePersonalizePageForm;


// WEBPACK FOOTER //
// ./src/components/PersonalizePageForm.js